import { Observable } from 'rxjs';
import {
  Dawa,
  GetSegmentSuggestionsRequest,
  SegmentSuggestions,
  Location,
  LocationType,
  PublicLocation,
  PrivateLocationsForPP,
} from '../domain/models';
import {
  CreateEditPrivateLocationRequest,
  GetStopsForPlanRequest,
  PrivateLocationRequest,
  PublicLocationRequest,
} from '../domain/requests';
import { CreateEditPublicLocationRequest } from '../domain/requests/create-edit-public-loction.request';
import { HttpResponse } from '@angular/common/http';
import { GetPrivateLocationsResponse } from '../domain/models/get-private-location.model';
import { SortingOptions } from '../domain/models/sorting-option.model';
import { CountryEntity } from '../domain/models/country.model';
import { Injectable } from "@angular/core";
import { Gls } from '../domain/models/gls.model';

@Injectable({providedIn: 'root'})
export abstract class LocationsRepository {
  abstract createEditPublicLocation(
    request: CreateEditPrivateLocationRequest
  ): Observable<CreateEditPrivateLocationRequest>;

  abstract getPrivateLocation(locationId: string): Observable<Location>;

  abstract exportLocations(): Observable<HttpResponse<Blob>>

  abstract deletePublicLocation(publicLocationId: string): Observable<boolean>;

  abstract deactivatePublicLocation(
    publicLocationId: string
  ): Observable<boolean>;

  abstract getPublicLocations(
    request: PublicLocationRequest
  ): Observable<PublicLocation[]>;

  abstract getPrivateLocations(
    request: PrivateLocationRequest
  ): Observable<GetPrivateLocationsResponse>;

  abstract getDawaAutoCompleteLocations(request: string): Observable<Dawa[]>;

  abstract getLocationsByAddressFromGLS(request: string): Observable<Gls[]>;

  abstract addPublicLocation(
    request: CreateEditPublicLocationRequest
  ): Observable<string>;

  abstract getPrivateLocationByMlsId(
    request: string
  ): Observable<PrivateLocationsForPP>;

  abstract getLocationType(): Observable<LocationType[]>;

  abstract importLocationsFromFile(request: FormData): Observable<boolean>;

  abstract getSampleLocationsImportFiles(): Observable<HttpResponse<Blob>>;

  abstract getSegmentSuggestions(
    request: GetSegmentSuggestionsRequest
  ): Observable<SegmentSuggestions[]>;

  abstract getStopsForPlan(
    request: GetStopsForPlanRequest
  ): Observable<PrivateLocationsForPP[]>;

  abstract getWayPointsForJob(request: string): Observable<number[][]>;

  abstract getCountryData(): Observable<CountryEntity[]>;

  abstract getSortingOptions(): Observable<SortingOptions[]>;
}
